const options = {
  5: "bg-indigo-300/5",
  10: "bg-indigo-300/10",
  25: "bg-indigo-300/25",
  50: "bg-indigo-300/50",
  75: "bg-indigo-300/75",
  90: "bg-indigo-300/90",
  100: "bg-indigo-300",
};

const from = {
  5: "from-indigo-300/5",
  10: "from-indigo-300/10",
  25: "from-indigo-300/25",
  50: "from-indigo-300/50",
  75: "from-indigo-300/75",
  90: "from-indigo-300/90",
  100: "from-indigo-300",
};

export default function getBackgroundIndigo300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
  